import React from 'react'
import createReactClass from 'create-react-class'
import ModalWrapper from './modal-wrapper'
import ModalContent from './modal-content'
import {copyToClipboard} from '../../util/helpers'

export default createReactClass({
  getInitialState () {
    return {
      infoMessage: '',
      copyError: false,
    }
  },
  onCopyURLToClipboard () {
    let success = copyToClipboard(this.props.reqUrl, document)
    if (success) {
      this.setState({infoMessage: 'URL copied to clipboard', copyError: false})
    } else {
      this.setState({infoMessage: 'URL not copied to clipboard', copyError: true})
    }
  },
  renderInfoMessage () {
    return this.state.infoMessage ? (
      <div className={this.state.copyError ? 'copy-message error' : 'copy-message'}>{this.state.infoMessage}</div>
    ) : false
  },
  render () {
    return (
      <ModalWrapper>
        <ModalContent title='View Request URL' {...this.props}>
          {this.renderInfoMessage()}
          {this.props.reqUrl ? (
            <div>
              <textarea className='request-url' defaultValue={this.props.reqUrl} cols="42" readOnly/>
              <div className='request-url-copy-button'>
                <button onClick={this.onCopyURLToClipboard} className="copy-button cs-primary-button">Copy URL to clipboard</button>
              </div>
            </div>
          ) : <div className="text-center">Request url has not build yet!</div>}
        </ModalContent>
      </ModalWrapper>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/modal-panels/view-url-modal-panel.js